/**
* users.js
*/
import 'select2'
import { initTableFilters } from '../src/table_filters'

/*
* on load initialization
*/
$(() => {
  $(":root")
    .on('click', '#bulk-assign-group', Formazione.on_bulk_group_action_selected)
    .on('click', '#bulk-remove-group', Formazione.on_bulk_group_action_selected)
    .on('confirm:complete', '#bulk-remove-account', Formazione.on_bulk_remove_account_selected)
    .on('confirm:complete', '#bulk-send-welcome-email', Formazione.on_bulk_send_welcome_email)
    .on('click', '.promote-test', Formazione.on_promote_test);
});

document.addEventListener('turbolinks:load', () => {
  initTableFilters({
    formId: 'users-filter-form',
    storageKey: 'users-filter-focus',
    ajax: true,
    targets: ['#filter-results', '#pagination-top', '#pagination-bottom'],
    paginationTargets: ['#pagination-top', '#pagination-bottom']
  });

  // Video watches checkbox filter (superadmin only)
  $(document).off('change.vw').on('change.vw', '#filter-has-video-watches-cb', function () {
    $('#filter-has-video-watches').val(this.checked ? '1' : '');
    $('#users-filter-form').submit();
  });
});

/*
* Formazione Class
*/
(function(Formazione, undefined) {

  var customerTag = () => $('#dataContainer').attr('data-customer-tag');

  /*
  * Show the outcome of a bulk/ajax action: errors list or success message, then reload.
  */
  Formazione.show_bulk_action_result = (data) => {
    var message =
      data.error && data.errors ?
        "<p>Si sono verificati i seguenti problemi:</p><ul>" +
        data.errors.map(e => `<li>${e}</li>`).join('') +
        "</ul>"
      :
        data.message;
    ModalMessage.show({
      type: data.error ? "warning" : "info",
      message: message,
      is_html: true,
      buttons: [{ text: "Chiudi", class: "btn-primary", callback: Formazione.reload_page }]
    });
  };

  /*
  * Require at least one selected user. Returns selected users array, or null (showing a warning).
  */
  function requireSelectedUsers() {
    var users = $('#users input.select-row:checked')
      .map(function() {
        var $row = $(this).closest("tr");
        return {
          id: $(this).attr("data-user-id"),
          customer_tag: $(this).attr("data-customer-tag"),
          cognome: $row.find("td#cognome").text(),
          nome: $row.find("td#nome").text()
        };
      })
      .get();
    if (users.length === 0) {
      ModalMessage.show({type: "warning", message: "Non hai selezionato nessun utente"});
      return null;
    }
    return users;
  }

  /*
  * POST JSON to a bulk action endpoint with selected users and optional extra data.
  * When customerTag is _all_, groups users by their customer_tag and sends
  * parallel requests with the correct customer_tag in the URL, then merges results.
  */
  function bulkPost(urlBuilder, extraData) {
    var users = requireSelectedUsers();
    if (!users) return;

    if (customerTag() !== '_all_') {
      // Single school: send one request
      $.ajax({
        type: 'POST',
        url: urlBuilder(customerTag()),
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          authenticity_token: Rails.csrfToken(),
          users: users,
          ...extraData
        })
      })
      .done(Formazione.show_bulk_action_result)
      .fail(Formazione.on_ajax_error);
      return;
    }

    // All schools: group users by customer_tag and send parallel requests
    var groups = {};
    users.forEach(function(u) {
      var tag = u.customer_tag || '_all_';
      if (!groups[tag]) groups[tag] = [];
      groups[tag].push(u);
    });

    var promises = Object.keys(groups).map(function(tag) {
      return $.ajax({
        type: 'POST',
        url: urlBuilder(tag),
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          authenticity_token: Rails.csrfToken(),
          users: groups[tag],
          ...extraData
        })
      });
    });

    $.when.apply($, promises)
      .then(function() {
        // Merge results from all responses
        var results = promises.length === 1 ? [arguments] : Array.from(arguments);
        var allErrors = [];
        var lastMessage = '';
        results.forEach(function(r) {
          var data = r[0];
          if (data.error && data.errors) allErrors = allErrors.concat(data.errors);
          if (data.message) lastMessage = data.message;
        });
        Formazione.show_bulk_action_result(
          allErrors.length > 0
            ? { error: true, errors: allErrors }
            : { message: lastMessage }
        );
      })
      .fail(Formazione.on_ajax_error);
  }

  /*
  * Bulk assign/remove groups: run the AJAX call from within the modal
  */
  Formazione.bulk_group_action_run = (modal_id, action) => {
    var urlBuilder = action == "assign" ?
      (tag) => Routes.customer_bulk_assign_groups_path({customer_tag: tag}) :
      (tag) => Routes.customer_bulk_remove_groups_path({customer_tag: tag});
    bulkPost(urlBuilder, { group_ids: $(`#${modal_id} #groups`).val() });
  };

  /*
  * Bulk group action: show modal with group selector
  */
  Formazione.on_bulk_group_action_selected = (event) => {
    event.preventDefault();
    var action = $(event.target).attr("id") == "bulk-assign-group" ? "assign" : "remove";

    if (!requireSelectedUsers()) return;

    ModalMessage.show({
      type: "info",
      is_html: true,
      title: action == "assign" ?
        "Seleziona i gruppi a cui associare gli utenti selezionati" :
        "Seleziona i gruppi da cui rimuovere gli utenti selezionati",
      message: $('#group-selector').html(),
      on_load: () => { $('select[multiple]').select2(); },
      buttons: [
        { text: "Annulla", class: "btn-outline-info" },
        {
          text: action == "assign" ? "Associa" : "Rimuovi",
          class: "btn-primary",
          callback: (modal_id) => { Formazione.bulk_group_action_run(modal_id, action) }
        }
      ]
    });
  };

  Formazione.on_bulk_remove_account_selected = (event) => {
    event.preventDefault();
    if (!requireSelectedUsers()) return;
    bulkPost((tag) => Routes.customer_bulk_remove_accounts_path({customer_tag: tag}));
  };

  Formazione.on_bulk_send_welcome_email = (event) => {
    event.preventDefault();
    if (!requireSelectedUsers()) return;
    bulkPost((tag) => Routes.customer_bulk_send_welcome_emails_path({customer_tag: tag}));
  };

  /*
  * Promote test: show modal and handle submission
  */
  Formazione.on_promote_test = (event) => {
    event.preventDefault();
    var userId = $(event.currentTarget).attr("data-user-id");

    var testServiceData = JSON.parse($('#promote-test-data').html());
    var optionsHtml = testServiceData.map(item =>
      `<option value="${item[1]}">${item[0]}</option>`
    ).join('');

    ModalMessage.show({
      type: "info",
      is_html: true,
      title: "Promuovi test",
      message:
        '<div class="form-group">' +
        '  <label for="promote-date">Data</label>' +
        '  <input id="promote-date" class="form-control" type="date">' +
        '</div>' +
        '<div class="form-group mt-3">' +
        '  <label for="promote-test-service">Corso</label>' +
        '  <select id="promote-test-service" class="form-control">' +
        '    <option value="">Seleziona...</option>' +
        optionsHtml +
        '  </select>' +
        '</div>',
      buttons: [
        { text: "Annulla", class: "btn-outline-info" },
        {
          text: "Promuovi",
          class: "btn-primary",
          callback: (modal_id) => {
            var date = $(`#${modal_id} #promote-date`).val();
            var testServiceId = $(`#${modal_id} #promote-test-service`).val();
            if (!date || !testServiceId) {
              ModalMessage.show({ type: "warning", message: "Compilare tutti i campi" });
              return;
            }
            $.ajax({
              type: 'POST',
              url: Routes.customer_user_promote_test_path(customerTag(), userId),
              dataType: 'json',
              contentType: 'application/json',
              data: JSON.stringify({
                authenticity_token: Rails.csrfToken(),
                test_service_id: testServiceId,
                date: date
              })
            })
            .done(Formazione.show_bulk_action_result)
            .fail(Formazione.on_ajax_error);
          }
        }
      ]
    });
  };

}(window.Formazione = window.Formazione || {}));
